// frontend/src/api/scheduler.js
import apiClient from './client';

export const scheduleSubmission = async (imageId, schedulingData) => {
  const response = await apiClient.post(`/scheduler/schedule/${imageId}`, {
    scheduled_for: schedulingData.scheduledFor.toISOString(),
    create_badge_removal_suggestions: schedulingData.createBadgeRemovalSuggestions !== undefined
      ? schedulingData.createBadgeRemovalSuggestions
      : true,
    is_badge_removal: schedulingData.isBadgeRemoval || false,  // Pass the badge removal flag
    original_badges: schedulingData.badgesToRemove || null,  // Pass which badges to remove
    publish_on_submit: schedulingData.publishOnSubmit !== undefined ? !!schedulingData.publishOnSubmit : true,
  });
  return response.data;
};

export const createBadgeRemovalSchedule = async (parentSubmissionId, badgeType, scheduledFor) => {
  const response = await apiClient.post(`/scheduler/schedule/badge-removal/${parentSubmissionId}`, {
    badge_type: badgeType,
    scheduled_for: scheduledFor.toISOString()
  });
  return response.data;
};

export const getScheduledSubmissions = async (status = null, allUsers = true) => {
  // Build URL with query parameters
  const params = new URLSearchParams();
  if (status) params.append('status', status);
  if (allUsers) params.append('all_users', 'true');
  
  const url = params.toString() 
    ? `/scheduler/scheduled?${params.toString()}`
    : `/scheduler/scheduled`;
  
  const response = await apiClient.get(url);
  return response.data;
};

export const updateScheduledSubmission = async (submissionId, updateData) => {
  const response = await apiClient.put(`/scheduler/scheduled/${submissionId}`, {
    scheduled_for: updateData.scheduledFor ? updateData.scheduledFor.toISOString() : undefined,
    status: updateData.status
  });
  return response.data;
};

export const cancelScheduledSubmission = async (submissionId) => {
  const response = await apiClient.delete(`/scheduler/scheduled/${submissionId}`);
  return response.data;
};

export const auditMissingBadgeRemovals = async () => {
  const response = await apiClient.get('/scheduler/audit/missing-badge-removals');
  return response.data;
};

export const fixMissingBadgeRemovals = async () => {
  const response = await apiClient.post('/scheduler/fix/missing-badge-removals');
  return response.data;
};

export const getBadgeReviewImages = async (imageId) => {
  const response = await apiClient.get(`/scheduler/badge-review/${imageId}`);
  return response.data;
};

export const dismissBadgeAuditItem = async (submissionId) => {
  const response = await apiClient.post(`/scheduler/dismiss-badge-audit/${submissionId}`);
  return response.data;
};

export const getScheduledSubmissionsForImage = async (imageId, status = null) => {
  const params = new URLSearchParams();
  if (status) params.append('status', status);

  const url = params.toString()
    ? `/scheduler/scheduled/image/${imageId}?${params.toString()}`
    : `/scheduler/scheduled/image/${imageId}`;

  const response = await apiClient.get(url);
  return response.data;
};